<template>
  <div>
    <el-card class="fatherCard">
      <!-- 考试报名页面-->
      <div slot="header" class="clearfix">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item class="currentLocation"><i class="el-icon-location-outline"></i> 当前位置</el-breadcrumb-item>
          <el-breadcrumb-item>考生考试</el-breadcrumb-item>
          <el-breadcrumb-item>在线考试</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <!--条件搜索区域-->
        <div class="search_container">
          <el-input v-model="examNameSearch" clearable placeholder="请输入考试名称" class="examNameSearchInput"></el-input>
          <el-button type="primary" @click="query()" class="searchButton">查询</el-button>
        </div>

        <!--考试信息展示表格-->
        <el-table :data="examList" border stripe max-height="600px" :header-cell-style="{background:'#eef1f6',color:'#606266'}">
          <el-table-column fixed="left" type="index" width="60" label="序号" align="center"></el-table-column>
          <el-table-column fixed="left" prop="examName" label="考试名称" width="250" align="center"></el-table-column>
          <el-table-column prop="examMsg" label="考试信息" width="250" align="center"></el-table-column>
          <el-table-column prop="examDuration" label="考试时长（分钟）" width="140" align="center"></el-table-column>
          <el-table-column prop="signEndTime" label="报名截止"  align="center"></el-table-column>
          <el-table-column prop="examStartTime" label="考试开始时间"  align="center"></el-table-column>
          <el-table-column prop="examEndTime" label="考试结束时间" align="center"></el-table-column>
          <!-- <el-table-column label="考试状态" width="150" align="center">
            <template slot-scope="scope">{{ scope.row.state }}</template>
          </el-table-column> -->
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.lastAnswerTime !== '' && !isTimedOut(scope.row.lastAnswerTime,scope.row.examDuration) && scope.row.hasHand == '0'" 
              @click="$router.push('/examPage?paperId='+scope.row.paperId+'&&lastTime='+getLastTime(scope.row.lastAnswerTime,scope.row.examDuration)+'&&examId='+scope.row.examId)" type="primary">继续考试</el-link>
              <el-link v-else-if="(scope.row.lastAnswerTime !== '' && isTimedOut(scope.row.lastAnswerTime,scope.row.examDuration)) || scope.row.hasHand != '0'" disabled type="primary">已结束</el-link>
              <el-link v-else :disabled="scope.row.state==2 ? true:false" @click="startExam(scope.row)" type="primary">进入考试</el-link>
            </template>
          </el-table-column>
        </el-table>

        <!--分页信息底栏-->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParam.pageNum" :page-sizes="[10,20,50]" :page-size="queryParam.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" class="page">
        </el-pagination>

        <!-- 考前提示 -->
        <el-dialog title="考试提示" :visible.sync="startExamDialog" center width="50%">
          <el-alert title="⚠注意：点击`开始考试`后将自动进入考试，若中途退出或刷新页面，系统将不会保留已作答内容，请在规定时长内完成并提交！" type="error">
          </el-alert>

          <el-card style="margin-top: 25px">
            <span>考试名称：</span>{{ currentSelectedExam.examName }}
            <br>
            <br>
            <span>考试描述：</span>{{ currentSelectedExam.examMsg }}
            <br>
            <br>
            <span>考试时长：</span>{{ currentSelectedExam.examDuration + '分钟' }}
            <br>
          </el-card>

          <span slot="footer" class="dialog-footer">
            <el-button @click="startExamDialog = false">返 回</el-button>
            <el-button type="primary" @click="startNow()">开始考试</el-button>
          </span>
        </el-dialog>

      </div>
    </el-card>
  </div>
</template>

<script>
import { queryExamsByUserId, recordAnswerTime } from '../../api/examinee';
export default {
	data() {
		return {
			examList: [], //对应的考试列表
			totalCount: 0, //总数据条数
			queryParam: {
				pageSize: 10,
				pageNum: 1,
				userId: ''
			},
			examNameSearch: '', //考试名称

			startExamDialog: false,
			currentSelectedExam: {}
		};
	},
	created() {
		this.getExamsByUserId();
	},
	mounted() {
		//this.getUserCanSignExams()
	},
	methods: {
		//查询该用户进行中的考试
		async getExamsByUserId() {
			this.queryParam.userId = JSON.parse(this.$store.state.loginInfo).userId;
			const res = await queryExamsByUserId(this.queryParam);
			if (res.data.code == 200) {
				this.examList = res.data.data.filter((item) => new Date(item.examEndTime) > new Date());
				this.totalCount = this.examList.length;
				if (res.data.data.length == 0) {
					this.$message({
						type: 'info',
						message: '未查到相关信息!'
					});
				}
				//console.log(res);
			}
		},
		//改变当前记录条数
		handleSizeChange(val) {
			this.queryParam.pageSize = val;
            this.queryParam.pageNum = 1;
			this.getExamsByUserId();
		},
		//改变当前页码，重新发送请求
		handleCurrentChange(val) {
			this.queryParam.pageNum = val;
			this.getExamsByUserId();
		},
		//根据考试名称查询考试
		query() {
			this.queryParam.examName = this.examNameSearch;
			this.getExamsByUserId();
		},

		// 进入考试
		startExam(row) {
			this.currentSelectedExam = row;
			this.startExamDialog = true;
		},

		// 开始考试
		async startNow() {
			const param = {
				examId: this.currentSelectedExam.examId,
				userId: JSON.parse(this.$store.state.loginInfo).userId,
				answerTime: this.myDateFormat('YYYY-mm-dd HH:MM:SS', new Date())
			};
			const res = await recordAnswerTime(param);
			console.log('res:', res);
			if (res.data.code == 200) {
				this.$router.push({
					path: '/examPage?paperId=' + this.currentSelectedExam.paperId + '&&lastTime=' + this.getLastTime(res.data.data, this.currentSelectedExam.examDuration) + '&&examId=' + this.currentSelectedExam.examId
				});
			}
		}
	}
};
</script>
<style lang="css" scoped>
.fatherCard {
	width: 1672px;
    position: absolute;
    height: 90vh;
}
.currentLocation {
	font-weight: bold;
}
/* .page-container {
	padding: 0px 20px;
} */
.page {
	margin-top: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.edit {
	margin-left: 20px;
}
.el-table tr {
	background-color: #dd5862 !important;
}
.el-table .warning-row {
	background: #000 !important;
}

.el-table .success-row {
	background: #dd5862;
}
/* .el-select {
        margin-right: 232px;
    }  */

.search_container {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	align-items: flex-end;
	/* justify-content: space-between; */
}
.search_container .el-input {
	width: 200px;
	margin-right: 10px;
}

.searchButton {
	margin-left: 30px;
}
</style>
